export const applyCompanyContextHeader = (config, companyContextId) => {
  const headers = config.headers || (config.headers = {});
  const explicitCompanyId = headers.get?.("X-Company-Id") ||
    headers["X-Company-Id"] || headers["x-company-id"];
  if (companyContextId && !explicitCompanyId) {
    headers["X-Company-Id"] = String(companyContextId);
  }
  return config;
};
